// Types partagés pour le système de modules

export interface ComponentMetadata {
    name: string;
    displayName: string;
    description: string;
    category: string;
    defaultParams: Record<string, unknown>;
    paramDefinitions: Record<string, {
        type: 'string' | 'number' | 'boolean';
        label: string;
        description?: string;
        file_types?: string; // Types de fichiers acceptés pour ce paramètre
        editable_by_dev?: boolean;  // Peut être édité par les développeurs
        editable_by_user?: boolean;  // Peut être édité par les utilisateurs finaux
    }>;
    outsideGrid: boolean;
    defaultEnabled: boolean;
}

// ============================================
// Types pour le système de médias et modules système
// ============================================

// Notification système
export interface SystemNotification {
    id: string;
    type: 'error' | 'warning' | 'info' | 'success';
    message: string;
    duration?: number;
    timestamp: Date;
}

// Annonce
export interface Announcement {
    id: string;
    message: string;
    type: 'info' | 'warning' | 'success';
    dismissible: boolean;
    priority: number;
}

// Interface pour ApiStatusBanner
export interface ApiStatusBannerProps {
    isOnline: boolean;
    lastCheck: Date | null;
    latency?: number;
    onDismiss?: () => void;
}

// Interface pour ErrorNotification
export interface ErrorNotificationProps {
    notifications: SystemNotification[];
    onDismiss: (id: string) => void;
}

// Interface pour AnnouncementBanner
export interface AnnouncementBannerProps {
    announcements: Announcement[];
    onClose: (id: string) => void;
}

// Modules système requis
export const REQUIRED_SYSTEM_MODULES = [
    'ApiStatusBanner',
    'ErrorNotification',
    'AnnouncementBanner'
] as const;

export type RequiredSystemModule = typeof REQUIRED_SYSTEM_MODULES[number];

// Configuration média
export interface MediaConfig {
    lazyLoadThreshold: string;
    enableProgressiveLoading: boolean;
    apiTimeout: number;
    defaultQuality: number; // Qualité par défaut en pourcentage (0-95)
    minQuality?: number; // Qualité minimale (défaut: 1)
    maxQuality?: number; // Qualité maximale (défaut: 95)
}


